import { Maybe } from 'maybeasy';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { T } from '../../../../../../Translations';
import { findLink } from '../../../../../../LinkyLinky';
import { currentUserStore } from '../../../../../../CurrentUserStore';

export interface Props {
  id: number;
}

export const participantAccessLink = ({ id }: Props): Maybe<React.ReactNode> =>
  findLink('learning-collection-invitations', currentUserStore.links).map(() => (
    <Link
      key="Manage Participant Access"
      to={`/learning_collections/${id}/invitations`}
      className="px-4 py-2.5"
      data-intercom-target="manage-participant-access-action"
    >
      <T kind="Manage Participant Access" />
    </Link>
  ));
